import styles from './index.module.css'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useApplicationCodeMutation } from '@/shared/api-rtk/api-list/cartApi.js'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'

export const PromoField = ({ codeAplied, userInfo }) => {
    const ref = useRef(null)
    const [toggle, setToggle] = useState(false)
    const [codeValue, setCodeValue] = useState('')
    const [sendCode, { isLoading }] = useApplicationCodeMutation()

    useEffect(() => {
        if (!!codeAplied) {
            setToggle(true)
        }
    }, [codeAplied])

    const onSubmit = async () => {
        if (ref.current) {
            sendCode({"userInfo": userInfo, "voucher": ref.current.value})
                .unwrap()
                .then((res) => {
                    if (res.success) {
                        TOAST_SUCCESS(res.success)
                    }
                    if (!res.error) {
                        window.location.reload()
                    }
                    if (res.error) {
                        TOAST_ERROR(res.error)
                    }
                })
                .catch((err) => {
                    TOAST_ERROR(err.message)
                })
        }
    }

    return (
        <div className={styles.wrapper}>
            <button
                onClick={() => setToggle(!toggle)}
                className={toggle ? styles.toggle : ''}
            >
                <span>
                    {!!codeAplied
                        ? 'Сертификат применён'
                        : 'Применить сертификат'}
                </span>
                <img src={'/icons/arrow-carousel.svg'} alt={'arrow'} />
            </button>
            <div
                className={classNames(styles.content, toggle && styles.toggled)}
            >
                <div className={styles.field}>
                    <input
                        disabled={!!codeAplied}
                        ref={ref}
                        value={!!codeAplied ? codeAplied : codeValue}
                        onChange={(e) => setCodeValue(e.target.value)}
                        type="text"
                        placeholder="Введите код"
                    />
                    <button
                        disabled={isLoading || !!codeAplied}
                        onClick={onSubmit}
                    >
                        Применить
                    </button>
                </div>
            </div>
        </div>
    )
}
